// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608240548/js/" + chunkId + "." + {"44":"6cd8f0e4","225":"5c72e6b7","481":"9014ddf6","486":"50ab6229","770":"74d453b7"}[chunkId] + ".0.33378657443282866.chunk.js";
};